import CreditOrDebitCard from './CreditOrDebitCard';

export default CreditOrDebitCard;
